import { useUnistyles } from "react-native-unistyles";
import { useCallback } from "react";

export type StripeState = "armed" | "disarmed";

/**
 * Hook that returns a function to get the stripe color for a given alarm state.
 * - Armed: dark purple (alarmStates.armed) - these are the thick stripes
 * - Disarmed: medium grey (grey[400]) for stripes on light grey background
 */
export function useStripeColor() {
  const { theme } = useUnistyles();
  return useCallback(
    (state: StripeState): string => {
      return state === "armed" ? (theme.colors.alarmStates.armed as string) : (theme.colors.grey[400] as string);
    },
    [theme],
  );
}

/**
 * Hook that returns a function to get the background color for a given alarm state.
 * - Armed: light purple (alarmStates.armed) - background for dark purple stripes
 * - Disarmed: light grey (alarmStates.disarmed) for two-tone grey effect with stripes
 */
export function useAlarmStateBackgroundColor() {
  const { theme } = useUnistyles();
  return useCallback(
    (state: StripeState): string => {
      return state === "armed" ? (theme.colors.purple[100] as string) : (theme.colors.alarmStates.disarmed as string);
    },
    [theme],
  );
}
